module.exports = __webpack_public_path__ + "img/icon (22).cb61762c.png";